if (!customElements.get('lia-flagship-gallery')) {
  customElements.define('lia-flagship-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.slides = [...this.querySelectorAll('[data-lia-slide]')];
      this.thumbs = [...this.querySelectorAll('[data-lia-thumb]')];
      this.index = 0;
      this.dialog = this.querySelector('dialog');
      this.thumbs.forEach((button, index) => button.addEventListener('click', () => this.show(index)));
      this.querySelector('[data-lia-prev]').addEventListener('click', () => this.show(this.index - 1));
      this.querySelector('[data-lia-next]').addEventListener('click', () => this.show(this.index + 1));
      this.querySelectorAll('[data-lia-zoom]').forEach(button => button.addEventListener('click', () => {
        const image = button.querySelector('img').cloneNode();
        image.removeAttribute('loading');
        image.sizes = '95vw';
        this.querySelector('[data-lia-dialog-image]').replaceChildren(image);
        this.lastFocus = button;
        this.dialog.showModal();
      }));
      this.querySelector('[data-lia-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); });
      this.dialog.addEventListener('close', () => this.lastFocus?.focus({preventScroll:true}));
      this.addEventListener('keydown', event => {
        if (this.dialog.open) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          if (event.target.hasAttribute('data-lia-thumb')) this.thumbs[this.index].focus({preventScroll:true});
        }
      });
      let start;
      const stage = this.querySelector('.lia-gallery__stage');
      stage.addEventListener('touchstart', event => {start = event.touches[0];}, {passive:true});
      stage.addEventListener('touchend', event => {
        if (!start) return;
        const end = event.changedTouches[0], dx = end.clientX - start.clientX, dy = end.clientY - start.clientY;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) this.show(this.index + (dx < 0 ? 1 : -1));
        start = null;
      }, {passive:true});
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {slide.hidden = i !== this.index;});
      this.thumbs.forEach((button, i) => {if (i === this.index) button.setAttribute('aria-current','true'); else button.removeAttribute('aria-current');});
      this.querySelector('[data-lia-caption]').textContent = this.slides[this.index].querySelector('figcaption').textContent;
      this.querySelector('[data-lia-count]').textContent = `${String(this.index + 1).padStart(2,'0')} / ${String(this.slides.length).padStart(2,'0')}`;
    }
  });
}
